module.exports = __webpack_public_path__ + "img/romance-love.f5ffff2a.jpg";